export interface TrackingData {
    client_id?: string;
    session_id?: string;
    source?: string;
    medium?: string;
    campaign?: string;
}

export function getTrackingData(): TrackingData {
    if (typeof window === 'undefined') return {};

    const urlParams = new URLSearchParams(window.location.search);

    const cookies = document.cookie.split(';').reduce(
        (acc, cookie) => {
            const [name, value] = cookie.trim().split('=');
            acc[name] = value;
            return acc;
        },
        {} as Record<string, string>,
    );

    let clientId, sessionId: string | undefined;

    if (cookies['_ga']) {
        const parts = cookies['_ga'].split('.');
        if (parts.length >= 4) {
            clientId = parts.slice(2).join('.');
        }
    }

    const sessionCookieKey = Object.keys(cookies).find(key => key.startsWith('_ga_'));
    if (sessionCookieKey && cookies[sessionCookieKey]) {
        const parts = cookies[sessionCookieKey].split('.');
        if (parts.length >= 3) {
            const sessionPart = parts[2];
            if (sessionPart.startsWith('s')) {
                const match = sessionPart.match(/^s(\d+)/);
                if (match) {
                    sessionId = match[1];
                }
            }
        }
    }

    return {
        source: urlParams.get('utm_source') || undefined,
        medium: urlParams.get('utm_medium') || undefined,
        campaign: urlParams.get('utm_campaign') || undefined,
        client_id: clientId,
        session_id: sessionId,
    };
}
